var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRewardCrown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_77",
    "data-name": "Elipse 77",
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    transform: "translate(27 522)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_34",
    "data-name": "Grupo 34",
    transform: "translate(-27 -522)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Crown_King_of_Business",
    "data-name": "Crown King of Business",
    transform: "translate(21.49 516.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1839",
    "data-name": "Trazado 1839",
    d: "M21.5,0A21.5,21.5,0,1,1,0,21.5,21.5,21.5,0,0,1,21.5,0Z",
    transform: "translate(5.51 5.51)",
    fill: "#ef5350"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_79",
    "data-name": "Elipse 79",
    cx: 18.599,
    cy: 18.599,
    r: 18.599,
    transform: "translate(8.411 8.411)",
    fill: "#ff7043"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1117",
    "data-name": "Grupo 1117"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1813",
    "data-name": "Trazado 1813",
    d: "M39.775,22.386A1.18,1.18,0,0,0,38.6,23.564a1.207,1.207,0,0,0,.113.508.939.939,0,0,0,.054.1,1.161,1.161,0,0,0,.173.221,1.037,1.037,0,0,0,.081.076c.016.011.027.022.043.032l-2.679,3.085-1.907-7.255a1.226,1.226,0,0,0,.27-.092.94.94,0,0,0,.1-.054,1.161,1.161,0,0,0,.221-.173,1.425,1.425,0,0,0,.205-.27l.032-.065a1.167,1.167,0,0,0,.108-.492,1.178,1.178,0,0,0-2.355,0,1.131,1.131,0,0,0,.108.492l.032.065a1.116,1.116,0,0,0,.205.27,1.161,1.161,0,0,0,.221.173l.043.027-2.912,5.921-3.446-9.146c.032-.011.065-.027.1-.038a1.166,1.166,0,0,0,.664-1.059,1.178,1.178,0,0,0-2.355,0,1.207,1.207,0,0,0,.113.508,1.161,1.161,0,0,0,.551.551.722.722,0,0,0,.1.038l-3.355,8.9-2.787-5.672a.19.19,0,0,0,.043-.027,1.161,1.161,0,0,0,.221-.173,1.425,1.425,0,0,0,.205-.27l.032-.065a1.167,1.167,0,0,0,.108-.492,1.178,1.178,0,0,0-2.355,0,1.131,1.131,0,0,0,.108.492l.032.065a1.116,1.116,0,0,0,.205.27,1.161,1.161,0,0,0,.221.173.616.616,0,0,0,.1.054,1.445,1.445,0,0,0,.27.092l-1.907,7.255L14.947,24.5c.016-.011.027-.022.043-.032a.538.538,0,0,0,.081-.076,1.161,1.161,0,0,0,.173-.221.616.616,0,0,0,.054-.1,1.164,1.164,0,0,0,.113-.508,1.178,1.178,0,0,0-2.355,0,1.207,1.207,0,0,0,.113.508.939.939,0,0,0,.054.1,1.161,1.161,0,0,0,.173.221,1.037,1.037,0,0,0,.081.076,1.182,1.182,0,0,0,.751.27h.054a15.747,15.747,0,0,1,.794,4.624H14.1a.5.5,0,0,0-.5.5v.049a.433.433,0,0,0,.027.113.373.373,0,0,0,.022.054.334.334,0,0,0,.059.092c.005.005.005.011.011.011a.508.508,0,0,0,.384.178h.745v3.679H14.1a.5.5,0,0,0-.5.5v.049a.433.433,0,0,0,.027.113.373.373,0,0,0,.022.054.335.335,0,0,0,.059.092c.005.005.005.011.011.011a.508.508,0,0,0,.384.178H39.7a.5.5,0,0,0,.5-.448v-.049a.5.5,0,0,0-.5-.5h-.745V30.365H39.7a.5.5,0,0,0,.5-.448v-.049a.5.5,0,0,0-.5-.5h-.778a15.747,15.747,0,0,1,.794-4.624h.054a1.182,1.182,0,0,0,.751-.27A.538.538,0,0,0,40.6,24.4a1.161,1.161,0,0,0,.173-.221.616.616,0,0,0,.054-.1,1.181,1.181,0,0,0-1.053-1.685Z",
    fill: "#382b73"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1110",
    "data-name": "Grupo 1110"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_731",
    "data-name": "Rect\\xE1ngulo 731",
    width: 24.115,
    height: 4.678,
    transform: "translate(14.845 28.787)",
    fill: "#ffc733"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_732",
    "data-name": "Rect\\xE1ngulo 732",
    width: 17.27,
    height: 4.678,
    transform: "translate(18.264 28.787)",
    fill: "#fede3a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1101",
    "data-name": "Grupo 1101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1099",
    "data-name": "Grupo 1099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1097",
    "data-name": "Grupo 1097"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1814",
    "data-name": "Trazado 1814",
    d: "M26.9,14.807,21.441,29.284H32.358Z",
    fill: "#ffc733"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1098",
    "data-name": "Grupo 1098"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1815",
    "data-name": "Trazado 1815",
    d: "M26.9,14.807,23.828,29.284H29.97Z",
    fill: "#fede3a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1100",
    "data-name": "Grupo 1100"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_80",
    "data-name": "Elipse 80",
    cx: 1.178,
    cy: 1.178,
    r: 1.178,
    transform: "translate(25.724 13.629)",
    fill: "#fede3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1816",
    "data-name": "Trazado 1816",
    d: "M26.9,15.509a1.172,1.172,0,0,1-1.151-.935,1.144,1.144,0,0,0-.027.238,1.178,1.178,0,1,0,2.355,0,1.144,1.144,0,0,0-.027-.238A1.177,1.177,0,0,1,26.9,15.509Z",
    fill: "#ffc733"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1105",
    "data-name": "Grupo 1105"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1102",
    "data-name": "Grupo 1102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1817",
    "data-name": "Trazado 1817",
    d: "M13.629,21.905a16.159,16.159,0,0,1,1.448,7.379h4.964Z",
    fill: "#ffc733"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1818",
    "data-name": "Trazado 1818",
    d: "M19.836,18.1,16.9,29.284h8.433Z",
    fill: "#ffc733"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1819",
    "data-name": "Trazado 1819",
    d: "M19.836,18.1l-.864,11.182h6.364Z",
    fill: "#fede3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1820",
    "data-name": "Trazado 1820",
    d: "M13.629,21.905c1.253,2.636,2.874,7.379,2.874,7.379h3.538Z",
    fill: "#fede3a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1103",
    "data-name": "Grupo 1103"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_81",
    "data-name": "Elipse 81",
    cx: 1.178,
    cy: 1.178,
    r: 1.178,
    transform: "translate(18.599 16.924)",
    fill: "#fede3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1821",
    "data-name": "Trazado 1821",
    d: "M19.777,18.8a1.172,1.172,0,0,1-1.151-.935,1.144,1.144,0,0,0-.027.238,1.178,1.178,0,1,0,2.355,0,1.144,1.144,0,0,0-.027-.238A1.172,1.172,0,0,1,19.777,18.8Z",
    fill: "#ffc733"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1104",
    "data-name": "Grupo 1104"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_82",
    "data-name": "Elipse 82",
    cx: 1.178,
    cy: 1.178,
    r: 1.178,
    transform: "translate(13.067 21.306)",
    fill: "#fede3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1822",
    "data-name": "Trazado 1822",
    d: "M14.245,23.18a1.172,1.172,0,0,1-1.151-.935,1.144,1.144,0,0,0-.027.238,1.178,1.178,0,0,0,2.355,0,1.144,1.144,0,0,0-.027-.238A1.172,1.172,0,0,1,14.245,23.18Z",
    fill: "#ffc733"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1109",
    "data-name": "Grupo 1109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1106",
    "data-name": "Grupo 1106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1823",
    "data-name": "Trazado 1823",
    d: "M40.391,21.905a16.159,16.159,0,0,0-1.448,7.379H33.979Z",
    fill: "#ffc733"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1824",
    "data-name": "Trazado 1824",
    d: "M34.184,18.1l2.933,11.182H28.685Z",
    fill: "#ffc733"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1825",
    "data-name": "Trazado 1825",
    d: "M34.184,18.1l.864,11.182H28.685Z",
    fill: "#fede3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1826",
    "data-name": "Trazado 1826",
    d: "M40.391,21.905c-1.253,2.636-2.874,7.379-2.874,7.379H33.979Z",
    fill: "#fede3a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1107",
    "data-name": "Grupo 1107"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_83",
    "data-name": "Elipse 83",
    cx: 1.178,
    cy: 1.178,
    r: 1.178,
    transform: "translate(33.066 16.924)",
    fill: "#fede3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1827",
    "data-name": "Trazado 1827",
    d: "M34.243,18.8a1.172,1.172,0,0,0,1.151-.935,1.144,1.144,0,0,1,.027.238,1.178,1.178,0,1,1-2.355,0,1.144,1.144,0,0,1,.027-.238A1.172,1.172,0,0,0,34.243,18.8Z",
    fill: "#ffc733"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1108",
    "data-name": "Grupo 1108"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_84",
    "data-name": "Elipse 84",
    cx: 1.178,
    cy: 1.178,
    r: 1.178,
    transform: "translate(38.597 21.306)",
    fill: "#fede3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1828",
    "data-name": "Trazado 1828",
    d: "M39.775,23.18a1.172,1.172,0,0,0,1.151-.935,1.144,1.144,0,0,1,.027.238,1.178,1.178,0,1,1-2.355,0,1.144,1.144,0,0,1,.027-.238A1.172,1.172,0,0,0,39.775,23.18Z",
    fill: "#ffc733"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1829",
    "data-name": "Trazado 1829",
    d: "M39.7,29.284H14.1a.5.5,0,0,1-.5-.5h0a.5.5,0,0,1,.5-.5H39.7a.5.5,0,0,1,.5.5h0A.5.5,0,0,1,39.7,29.284Z",
    fill: "#1caee4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1830",
    "data-name": "Trazado 1830",
    d: "M14.1,29.284H39.7a.5.5,0,0,0,.5-.5H13.6A.5.5,0,0,0,14.1,29.284Z",
    fill: "#177bc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1831",
    "data-name": "Trazado 1831",
    d: "M39.7,33.968H14.1a.5.5,0,0,1-.5-.5h0a.5.5,0,0,1,.5-.5H39.7a.5.5,0,0,1,.5.5h0A.508.508,0,0,1,39.7,33.968Z",
    fill: "#1caee4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1832",
    "data-name": "Trazado 1832",
    d: "M14.1,33.968H39.7a.5.5,0,0,0,.5-.5H13.6A.5.5,0,0,0,14.1,33.968Z",
    fill: "#177bc0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_733",
    "data-name": "Rect\\xE1ngulo 733",
    width: 24.115,
    height: 0.459,
    transform: "translate(14.845 29.284)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1111",
    "data-name": "Grupo 1111"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_85",
    "data-name": "Elipse 85",
    cx: 0.929,
    cy: 0.929,
    r: 0.929,
    transform: "translate(34.384 30.575)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_86",
    "data-name": "Elipse 86",
    cx: 0.929,
    cy: 0.929,
    r: 0.929,
    transform: "translate(28.777 30.575)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_87",
    "data-name": "Elipse 87",
    cx: 0.929,
    cy: 0.929,
    r: 0.929,
    transform: "translate(23.169 30.575)",
    fill: "#d1d3d4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_88",
    "data-name": "Elipse 88",
    cx: 0.929,
    cy: 0.929,
    r: 0.929,
    transform: "translate(17.562 30.575)",
    fill: "#d1d3d4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1116",
    "data-name": "Grupo 1116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1112",
    "data-name": "Grupo 1112"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_89",
    "data-name": "Elipse 89",
    cx: 0.929,
    cy: 0.929,
    r: 0.929,
    transform: "translate(34.384 30.197)",
    fill: "#ef5a9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1833",
    "data-name": "Trazado 1833",
    d: "M35.313,31.634a.922.922,0,0,1-.9-.718.854.854,0,0,0-.022.205.929.929,0,1,0,1.858,0,1.257,1.257,0,0,0-.022-.205A.953.953,0,0,1,35.313,31.634Z",
    fill: "#a72973"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1113",
    "data-name": "Grupo 1113"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_90",
    "data-name": "Elipse 90",
    cx: 0.929,
    cy: 0.929,
    r: 0.929,
    transform: "translate(28.777 30.197)",
    fill: "#ef5a9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1834",
    "data-name": "Trazado 1834",
    d: "M29.706,31.634a.922.922,0,0,1-.9-.718.854.854,0,0,0-.022.205.929.929,0,1,0,1.858,0,1.257,1.257,0,0,0-.022-.205A.953.953,0,0,1,29.706,31.634Z",
    fill: "#a72973"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1114",
    "data-name": "Grupo 1114"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_91",
    "data-name": "Elipse 91",
    cx: 0.929,
    cy: 0.929,
    r: 0.929,
    transform: "translate(23.169 30.197)",
    fill: "#ef5a9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1835",
    "data-name": "Trazado 1835",
    d: "M24.1,31.634a.922.922,0,0,1-.9-.718.854.854,0,0,0-.022.205.929.929,0,1,0,1.858,0,1.258,1.258,0,0,0-.022-.205A.953.953,0,0,1,24.1,31.634Z",
    fill: "#a72973"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1115",
    "data-name": "Grupo 1115"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_92",
    "data-name": "Elipse 92",
    cx: 0.929,
    cy: 0.929,
    r: 0.929,
    transform: "translate(17.562 30.197)",
    fill: "#ef5a9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1836",
    "data-name": "Trazado 1836",
    d: "M18.491,31.634a.922.922,0,0,1-.9-.718.854.854,0,0,0-.022.205.929.929,0,1,0,1.858,0,1.258,1.258,0,0,0-.022-.205A.953.953,0,0,1,18.491,31.634Z",
    fill: "#a72973"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1837",
    "data-name": "Trazado 1837",
    d: "M35.615,21.721l.292.945a.941.941,0,0,0,.621.621l.945.292a.084.084,0,0,1,0,.162l-.945.292a.941.941,0,0,0-.621.621l-.292.945a.084.084,0,0,1-.162,0l-.292-.945a.941.941,0,0,0-.621-.621l-.945-.292a.084.084,0,0,1,0-.162l.945-.292a.941.941,0,0,0,.621-.621l.292-.945A.084.084,0,0,1,35.615,21.721Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1838",
    "data-name": "Trazado 1838",
    d: "M25.789,23.04l.238.767a.755.755,0,0,0,.5.5l.767.238a.071.071,0,0,1,0,.135l-.767.238a.755.755,0,0,0-.5.5l-.238.767a.071.071,0,0,1-.135,0l-.238-.767a.755.755,0,0,0-.5-.5l-.767-.238a.071.071,0,0,1,0-.135l.767-.238a.755.755,0,0,0,.5-.5l.238-.767A.071.071,0,0,1,25.789,23.04Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardCrown);
export default __webpack_public_path__ + "static/media/Reward_crown.89cb089b64f5d85c1af30d26cc93ec80.svg";
export { ForwardRef as ReactComponent };